import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';
import {
  OrganizationLeaderboardResponse,
  OrganizationBandsResponse,
} from '@/types/organizationLeaderboard';

const organizationLeaderboardEndpoint = `${apiUrl}metrics/organizationLeaderboard/`;

const emptyLeaderboardResponse = (
  status?: number
): OrganizationLeaderboardResponse => ({
  organizations: [],
  total_organizations: 0,
  current_org_rank: null,
  error: status ? `Failed to fetch data (${status})` : 'Failed to fetch data',
});

const emptyBandsResponse = (status?: number): OrganizationBandsResponse => ({
  organizations: [],
  total_organizations: 0,
  current_org_rank: null,
  error: status ? `Failed to fetch data (${status})` : 'Failed to fetch data',
});

export const fetchOrganizationLeaderboard = async (
  timeRange: string = 'weekly',
  currentOrgUUID: string | undefined
): Promise<OrganizationLeaderboardResponse> => {
  try {
    if (timeRange === 'weekly') {
      timeRange = 'this_week';
    } else if (timeRange === 'monthly') {
      timeRange = 'this_month';
    } else if (timeRange === 'yearly') {
      timeRange = 'this_year';
    }

    const requestBody = {
      date_range: timeRange,
      current_org_uuid: currentOrgUUID,
      date_interval: null,
    };

    const response = await postWithAuth(
      organizationLeaderboardEndpoint,
      requestBody
    );

    if (!response.ok) {
      return emptyLeaderboardResponse(response.status);
    }
    const data = await response.json();
    return data;
  } catch {
    return emptyLeaderboardResponse();
  }
};

export const fetchOrganizationLeaderboardBands = async (
  timeRange: string = 'weekly',
  currentOrgUUID: string | undefined
): Promise<OrganizationBandsResponse> => {
  try {
    const requestBody = {
      date_range: timeRange,
      current_org_uuid: currentOrgUUID,
      date_interval: null,
      bands: true,
    };

    const response = await postWithAuth(
      organizationLeaderboardEndpoint,
      requestBody
    );

    if (!response.ok) {
      return emptyBandsResponse(response.status);
    }
    const data = await response.json();
    return data;
  } catch {
    return emptyBandsResponse();
  }
};

const fetchOrganizationLeaderboardByOrg = async (
  timeRange: string = 'weekly',
  orgUUID: string
): Promise<OrganizationLeaderboardResponse> => {
  try {
    if (timeRange === 'weekly') {
      timeRange = 'this_week';
    } else if (timeRange === 'monthly') {
      timeRange = 'this_month';
    }
    const requestBody = {
      date_range: timeRange,
      date_interval: null,
      current_org_uuid: orgUUID,
    };
    const response = await postWithAuth(
      `${apiUrl}metrics/organizationLeaderboard/`,
      requestBody
    );

    if (!response.ok) {
      return emptyLeaderboardResponse(response.status);
    }

    const data = await response.json();
    return data;
  } catch {
    return emptyLeaderboardResponse();
  }
};
